import script from "./EditClient.vue?vue&type=script&setup=true&lang=js"
export * from "./EditClient.vue?vue&type=script&setup=true&lang=js"

import "./EditClient.vue?vue&type=style&index=0&id=5ef68e36&lang=css"

const __exports__ = script;

export default __exports__